export default {
    dependencies: ['$element', 'filtersservice'],
    callable(ele, filtersservice) {
        ele.addEventListener('click', event => {
            event.stopPropagation();
            if (filtersservice) {
                filtersservice.hide();
            }
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/hideFilters.js